import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import { META_SKIP_ERROR_PAGE } from '../../constants';

export const loadingComplete = createAction(types.LOADING_COMPLETE);

export const loadInitData = createApiAction(
  types.LOAD_INIT_DATA,
  (request) => request,
  { meta: META_SKIP_ERROR_PAGE },
);
